"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackedContext = void 0;

var react_1 = __importDefault(require("react"));

var dynamic_1 = require("./dynamic");

var StackedContext =
/** @class */
function () {
  function StackedContext(internalContext) {
    this.context = internalContext;
    this.useValue = this.context.useValue;
  }

  StackedContext.create = function (defaultValue, options) {
    var dynamicContext = dynamic_1.DynamicContext.create(defaultValue, "value", options);
    return new StackedContext(dynamicContext);
  };

  StackedContext.prototype.addProvider = function (outValueHook) {
    var _this = this;

    var component = function component(_a) {
      var children = _a.children,
          rawValue = _a.value;

      var prevProviderValue = _this.context.useRawValue();

      var value = outValueHook(rawValue, prevProviderValue);
      return react_1.default.createElement.apply(react_1.default, __spreadArrays([_this.context.Provider, {
        value: value
      }], toArray(children)));
    };

    return component;
  };

  return StackedContext;
}();

exports.StackedContext = StackedContext;

var toArray = function toArray(el) {
  if (Array.isArray(el)) return el;
  return [el];
};